import React, { useState } from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function ImageSlider({ imageList = [] }) {
  const [activeIndex, setActiveIndex] = useState(0);

  if (!imageList || imageList.length === 0) return null;

  const displayImages = imageList;

  // Generate exactly 7 thumbnails
  const thumbnails = Array.from({ length: 7 }, (_, i) => {
    if (displayImages.length === 1) {
      return displayImages[0];
    }
    return displayImages[i % displayImages.length];
  });

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? 6 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === 6 ? 0 : prev + 1));
  };

  const activeImage = displayImages.length === 1 
    ? displayImages[0] 
    : displayImages[activeIndex % displayImages.length];

  return (
    <div className="w-full">
      {/* Main Image Container */}
      <div className="relative w-full h-56 rounded-lg overflow-hidden my-3">
        <img
          src={activeImage}
          className="w-full h-full object-cover"
          alt="Main Listing"
        />

        {/* Left Arrow Icon */}
        <button
          type="button"
          onClick={handlePrev}
          className="absolute left-3 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-white flex items-center justify-center shadow-md hover:bg-gray-100 transition duration-200"
          style={{ border: 'none', cursor: 'pointer' }}
        >
          <ChevronLeftIcon className="text-gray-700 !text-[16px]" />
        </button>

        {/* Right Arrow Icon */}
        <button
          type="button"
          onClick={handleNext}
          className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-white flex items-center justify-center shadow-md hover:bg-gray-100 transition duration-200"
          style={{ border: 'none', cursor: 'pointer' }}
        >
          <ChevronRightIcon className="text-gray-700 !text-[16px]" />
        </button>
      </div>

      {/* Thumbnails Row */}
      <div className="grid grid-cols-7 gap-2">
        {thumbnails.map((thumbUrl, idx) => {
          const isSelected = idx === activeIndex;
          return (
            <div
              key={idx}
              onClick={() => setActiveIndex(idx)}
              className={`h-16 rounded overflow-hidden cursor-pointer border transition duration-200 ${
                isSelected ? 'border-[#00BC67]' : 'border-transparent'
              }`}
            >
              <img
                src={thumbUrl}
                alt={`Thumbnail ${idx}`}
                className="w-full h-full object-cover"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ImageSlider;